import { render, staticRenderFns } from "./reports-test.vue?vue&type=template&id=28827194"
import script from "./reports-test.vue?vue&type=script&lang=js"
export * from "./reports-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports